import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 24,
  medium: 15,
  small: 12,
  xSmall: 9
};
const FavoriteFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6406 9.68848L15.001 10.334L14.3616 9.68848C12.7924 8.10384 10.2463 8.10384 8.67709 9.68848C7.15124 11.2294 7.10377 13.7186 8.56434 15.297L8.67074 15.4086L15.0011 21.8015L21.3085 15.4322L21.4152 15.3211C22.8956 13.7217 22.854 11.2324 21.3251 9.68848C19.756 8.10384 17.2098 8.10384 15.6406 9.68848Z",
        fill: "currentColor"
      }
    )
  );
};
FavoriteFilledIcon.iconName = "FavoriteFilledIcon";

export { FavoriteFilledIcon };
